import {AdminCategoryContent} from '@/components/main/directory/admin/AdminCategoryContent';
import {AdminCategoryMenu} from '@/components/main/directory/admin/AdminCategoryMenu';

/**
 * [탐색 -> 어드민 칩 선택] 영역 컨테이너
 */
const AdminCategory = ({categoryName, categoryType}) => {
  return (
    <>
      <AdminCategoryMenu />
      <div id='container' className='_category'>
        <AdminCategoryContent
          categoryName={categoryName}
          categoryType={categoryType}
        />
      </div>
    </>
  );
};

export default AdminCategory;
